import {ChangeTabEvent} from '../opac.directive';
import {Inject} from 'ng-metadata/core';

import {PrimoResponse} from '../../../../../infra/dataStructures/PrimoResponses/ils.interface';
import {Component,Output,Input,EventEmitter} from 'ng-metadata/core';

import serviceProviders, { RequestService } from './request.service';
import serviceProviders, { LocationsService } from '../locations/locations.service';
//your imports go here
import {OpacService,StatusMsg} from '../opac.service';

import {FormBuilderService} from '../../../../../infra/formBuilder/formBuilder.service';
import {FormBuilderEnums} from '../../../../../infra/formBuilder/formBuilder.service';
import {DateUtils} from '../../../../../nddUtils/dateUtils.service';
import {OPAC_TAB} from '../opac.directive';
import { ServiceButtonService } from '../serviceButton.service';
import {getVid,getInstitutionCode, getPrimoVeAlternativeEmailDigitalResourceSharing} from '../../../../..//appConfig/appConfigForward';
import {ConfigurationUtil} from '../../../../..//nddUtils/configurationUtil.service';
import {Subscription} from "rxjs";

const indexOf = require('lodash/indexOf');
const filter = require('lodash/filter');
const forEach= require('lodash/forEach');
const cloneDeep= require('lodash/cloneDeep');
const get = require('lodash/get');

@Component({
    selector: 'prm-request',
    templateUrl: 'components/search/fullView/getit/opac/request/request.html'
})


export class PrmRequest{

    @Input() private blankService: string;
    @Input() public service;
    @Output() private changeTabEvent: EventEmitter<ChangeTabEvent> = new EventEmitter();
    private vid:string = getVid();
    private blankRequests;
    private itemAvailability: boolean;
    private itemAvailabilityCheckInProgress: boolean;
    private formInputChangedSinceLastAvailabilityCheck: boolean = false;
    private availabilityCheckRan: boolean = false;
    private subscription: Subscription;

    constructor(private requestService : RequestService,
                private opacService : OpacService,
                private formBuilderService : FormBuilderService,
                private dateUtils: DateUtils,
                private serviceButtonService: ServiceButtonService,
                private locationsService : LocationsService,
                @Inject('restBaseURLs') private restBaseURLs :Object,
                private configurationUtil: ConfigurationUtil,
                @Inject('$scope') private $scope: ng.IScope) {
        this.blankRequests = {
            'AlmaResourceSharing': {
                'allowed':"Y",
                'link-to-service':"/primaws/rest/priv/ILSServices/titleServices/-1/-1/AlmaResourceSharing?institution=",
                'service-type':"OvP",
                'type':"AlmaResourceSharing"
            },
            'AlmaPurchaseRequest': {
                'allowed':"Y",
                'link-to-service':"/primaws/rest/priv/ILSServices/titleServices/-1/-1/AlmaPurchaseRequest?institution=",
                'service-type':"OvP",
                'type':"AlmaPurchaseRequest"
            }
        };

        //subscribe to observable to know when a new form is opened
        this.subscription = this.requestService.newFormObservable.subscribe(()=>{
            this.availabilityCheckRan = false;
            if (this.isCheckAvailabilityEnabledForForm() && !this.blankService){
                setTimeout(()=>{this.checkAvailability();}, 200);
            }
        });

        //watch form data to fire handler when some input field changes
        this.$scope.$watch('$ctrl.formData', ()=>{this.onFormInputChange()}, true);

    }

    ngOnInit() {
        this.requestService.requestIsLoading = false;
        this.requestService.displayErrorMessage = false;
        if (this.blankService === 'AlmaResourceSharing') {
            this.requestService.requestIsLoading = true;
            console.log('blankService - AlmaResourceSharing');
            this.requestService.service = this.blankRequests['AlmaResourceSharing'];
            this.requestService.service['link-to-service']=this.requestService.service['link-to-service']+getInstitutionCode();
            let reqParams = {'vid':this.vid};
            this.serviceButtonService.makeIlsRequest(this.requestService.service, reqParams);
        }
        if (this.blankService === 'AlmaPurchaseRequest') {
            this.requestService.requestIsLoading = true;
            this.requestService.service = this.blankRequests['AlmaPurchaseRequest'];
            this.requestService.service['link-to-service']=this.requestService.service['link-to-service']+getInstitutionCode();
            let reqParams = {'vid':this.vid};
            this.serviceButtonService.makeIlsRequest(this.requestService.service, reqParams);
        }

    }

    ngOnDestroy(){
        this.subscription.unsubscribe();
    }

	get serviceType():string{
		let service = this.requestService.service;
		if(service === undefined){
			return '';
		}
		return service.type;
	}

    get form() {
        return this.getFilteredForm([
                                         FormBuilderEnums.UI_TYPE.LABEL,
                                         FormBuilderEnums.UI_TYPE.MULTI_LABEL
                                    ], false);
      }

    get formReadonly() {
        return this.getFilteredForm([
                                         FormBuilderEnums.UI_TYPE.LABEL,
                                         FormBuilderEnums.UI_TYPE.MULTI_LABEL
                                    ], true);
    }

	get requestHeader(){
		switch(this.serviceType){
			case 'ILL'				: return 'nui.ill.header';
			case 'PhotocopyRequest' : return 'nui.PhotocopyRequest.header';
            case 'HoldRequest'   	: return 'nui.HoldRequest.header';
            case 'CallSlip'         : return 'nui.CallSlip.header';
            case 'ShortLoan'        : return 'nui.shortloan.header';
			case 'UBRequest'		: return 'nui.ubrequest.header';
			case 'Recall'			: return 'nui.Recall.header';
            case 'AlmaDigitization'   : return 'almaDigitization.header';
            case 'AlmaPurchaseRequest'   : return 'almaPurchaseRequest.header';
            case 'AlmaRequest'   : return 'almaRequest.header';
            case 'AlmaRequestAnyItem'   : return 'almaRequestAnyItem.header';
            case 'AlmaRequestOther'   : return 'almaRequestOther.header';
            case 'AlmaDigitizationOther'   : return 'almaDigitizationOther.header';
            case 'AlmaItemDigitization'   : return 'almaItemDigitization.header';
            case 'AlmaItemRequest'   : return 'almaItemRequest.header';
            case 'AlmaResourceSharing'   : return 'almaResourceSharing.header';
            default                 : return '';
		}
	}

	get submitLabel(){
        switch(this.serviceType){
            case 'PhotocopyRequest' : return 'nui.PhotocopyRequest.send';
            case 'AlmaDigitization'   : return 'almaDigitization.send';
            case 'AlmaDigitizationOther'   : return 'almaDigitization.send';
            case 'AlmaItemDigitization'   : return 'almaDigitization.send';
            default                 : return 'nui.request.send';
        }
    }

    get formData() {
        return this.requestService.formData;
    }

    set formData(formData) {
        this.requestService.formData = formData;
    }

    get displayForm() {
        return this.getFilteredForm([
                                         FormBuilderEnums.UI_TYPE.LABEL,
                                         FormBuilderEnums.UI_TYPE.MULTI_LABEL,
                                         FormBuilderEnums.UI_TYPE.HIDDEN
                                    ], false).length > 0;
    }

    /* public functions */
    public submit(isValid) {
		let service :PrimoResponse.Ils.IRequestService = cloneDeep(this.requestService.service);
        let postData= cloneDeep(this.formData);

         if (this.isCopyRight(service) && this.isCopyRight(service) instanceof Array && this.isCopyRight(service).length > 0) {
            let eventData: ChangeTabEvent = {
                referer: OPAC_TAB.REQUEST,
                dest: OPAC_TAB.COPYRIGHTS
            };
            this.changeTabEvent.emit(eventData);
            return;
        }

        if (this.serviceType === "AlmaResourceSharing" && getPrimoVeAlternativeEmailDigitalResourceSharing() && this.getFilteredForm(["hidden"], true).filter(el => {return "alternativeLocationEmail" === el.key}).length > 0 ) {
            this.opacService.responseStatus = new StatusMsg(false, "the request could not be completed due to configuration issue - please contact your library");
            let eventData: ChangeTabEvent = {
                referer: OPAC_TAB.REQUEST,
                dest: OPAC_TAB.RESPONSE,
            };
            this.changeTabEvent.emit(eventData);
            return;
        }

        if (!postData.group_id) { //set it as ILS API ID
              postData.group_id = this.requestService.ilsApiId;
        }

        let itemId = postData.item_id || postData['request-option'];
        if (itemId) { //special case - request by item level
            /* update API to item level */
                service['link-to-service'] = service['link-to-service']+'/item/'+ itemId;
        }

        let itemId = postData.item_id || postData.itemId;
        this.manipulatePostData(postData);
        let mmsId = itemId ? undefined : postData.group_id;
        this.opacService.makeIlsCall(service,postData,'POST')
        	.then((res) => {
            	this.opacService.responseStatus = new StatusMsg(res.status === 'ok', res['reply-text']);
            	let eventData: ChangeTabEvent = {
                	referer: OPAC_TAB.REQUEST,
                	dest: OPAC_TAB.RESPONSE,
                    itemId: itemId,
                    mmsId: mmsId
            	};
            	this.changeTabEvent.emit(eventData);

       		});
    }

    public resetForm() {
        this.requestService.setupNewForm(this.requestService.service, this.requestService.ilsData, true);
    }

    private isCopyRight(service) {
        return this.requestService.isCopyRight(service);
    }

    private getFilteredForm(filters, isExists) {
        if (!this.requestService.form) {
            return [];
        }

        return this.requestService.form.filter((el) => {
                 return isExists ? indexOf(filters, el.uiType) > -1 : indexOf(filters, el.uiType) < 0;
        });
    }

     private manipulatePostData(postData){
        forEach(postData, (value,key)=>{
            let field= this.getFieldByName(this.requestService.form, key);
            if (field) {
                 if (field.fieldType === FormBuilderEnums.FIELD_TYPE.INTERNAL){
                    delete postData[key];
                    return;
                }
                if (field.uiType === FormBuilderEnums.UI_TYPE.DATE){
                    postData[key]= this.dateUtils.convertDateTypeToIlsDateString(postData[key]);
                }
                if (field.uiType === FormBuilderEnums.UI_TYPE.DATE_AND_TIME){
                    postData[key]= this.dateUtils.convertDateANDTimeTypeToIlsDate(postData[key]);
                }
            }
            if(key === "pickupLocation" || key === "pickupLocationFulNet" ){
                if(postData[key].indexOf("$$") !== -1){
                    let pickupLocation = postData[key].slice(0,postData[key].indexOf("$"));
                    let pickupLocationType = postData[key].slice(postData[key].indexOf("$$")+2);
                    postData[key] = pickupLocation;
                    postData["pickupLibraryId"] = pickupLocation;
                    postData["pickupType"] = pickupLocationType;
                }
            }
        });
    }

    private getFieldByName(form, name) {
        let matchedFields = filter(form, (el) => { return el.name === name; });
        return matchedFields[0];
    }

    public isCheckAvailabilityEnabledForForm(){
        return this.serviceType === 'AlmaResourceSharing' && this.requestService.isCheckAvailabilityEnabled;
    }

    private checkAvailability(){
        this.itemAvailabilityCheckInProgress = true;
        this.availabilityCheckRan = true;
        this.formInputChangedSinceLastAvailabilityCheck = false;
        this.requestService.checkAvailability().then((response : {data:boolean})=>{
            this.itemAvailability = response.data === null? undefined : response.data;
        }, (err)=>{
            this.itemAvailability = undefined;
        }).finally(()=>{
            this.itemAvailabilityCheckInProgress = false;
        });
    }

    public isCheckAvailabilityButtonDisabled(){
        return this.itemAvailability === true && !this.formInputChangedSinceLastAvailabilityCheck;
    }

    private onFormInputChange(){
        console.log('input changed');
        this.formInputChangedSinceLastAvailabilityCheck = true;
    }

 }


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/request/request.directive.ts